import { styled } from 'stitches.config'
import { Stack } from 'components/Stack'
import { Text } from 'components/Text'

export const HeroRoot = styled('div', {
  backgroundColor: '$secondary-500',
  width: '100%',
  height: '100%',
  color: '$accent-white',
})

export const DesktopImageColumn = styled('div', {
  display: 'none',
  position: 'relative',
  '@bp2': {
    width: '49.2%',
    aspectRatio: '2.023',
    display: 'block',
    lineHeight: 0,
  },
})

export const MobileImageColumn = styled('div', {
  display: 'block',
  width: '100%',
  margin: 'auto',
  textAlign: 'center',
  lineHeight: 0,
  '@bp2': {
    display: 'none',
  },
})

export const CopyColumn = styled(Stack, {
  padding: '$3',
  width: '100%',

  '@bp2': {
    width: '50.8%',
  },
})

export const Layout = styled(Stack, {
  margin: 'auto',
  maxWidth: '500px',
  '@bp2': {
    maxWidth: '2400px',
  },
})

export const Header = styled('h1', {
  fontSize: '$h2',
  fontFamily: '$display',
  fontWeight: '$regular',
  textAlign: 'center',
  '@bp2': {
    fontSize: '$h1'
  }
})